<aero-accordion *transloco="let t; read: 'resume'">
  <aero-accordion-tab [(selected)]="open" [panelValue]="sectionName" (selectedChange)="onSelectedChange($event, sectionName)">
    <div class="bulb-resume-section-header" header>
      <span>{{sectionName}}</span>
      <ng-container *ngIf="showEditIcon && canEdit">
        <button class="bulb-resume-section-icon" (keyup.enter)="onEditIconClick($event, sectionName)" (click)="onEditIconClick($event, sectionName)"
          aeroTooltipPosition="top" aeroTooltip="{{ t('editSection') }}"
          attr.aria-label="{{ t('editSection') }}">
          <i class="far fa-pencil"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="showDeleteIcon">
        <button class="bulb-resume-section-icon" (keyup.enter)="deleteResumeSection($event)" (click)="deleteResumeSection($event)"
                aeroTooltipPosition="top" aeroTooltip="{{ t('deleteSection') }}"
                attr.aria-label="{{ t('deleteSection') }}">
          <i class="fal fa-trash-alt"></i>
        </button>
      </ng-container>
    </div>

    <div *ngIf="showContent" class="bulb-resume-section-content" content>
      <ng-content select="[sectionContent]"></ng-content>
      <div *ngIf="showAddEntryButton" class="bulb-add-entry-button">
        <aero-button [aeroStyle]="buttonStyle" [icon]="'fal fa-plus'" [size]="buttonSize"
          label="{{ 'resume.add.entry' | transloco }}" (onClick)="addNewEntry($event)">
        </aero-button>
      </div>
    </div>

  </aero-accordion-tab>
</aero-accordion>
